import {authFetch} from "../../authentication/authFetch";

const API_URL = process.env.REACT_APP_API_URL;

function normalizeProject(project) {
    if (!project) return null;

    const startDate = project.startDate ?? project.start_date ?? null;
    const endDate = project.endDate ?? project.end_date ?? null;
    const userId = project.userId ?? project.user_id ?? null;

    return {
        ...project,
        userId,
        user_id: userId,
        startDate,
        start_date: startDate,
        endDate,
        end_date: endDate,
    };
}

function serializeProject(projectData) {
    if (!projectData) return {};

    const startDate = projectData.start_date ?? projectData.startDate;
    const endDate = projectData.end_date ?? projectData.endDate;
    const userId = projectData.user_id ?? projectData.userId;

    return {
        ...projectData,
        userId,
        user_id: userId,
        startDate,
        start_date: startDate,
        endDate,
        end_date: endDate,
    };
}


export const fetchProject = async (token, id) =>{
    try {
    const response = await authFetch(`${API_URL}/api/project/${id}`, {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
        })
        if (!response.ok) throw new Error('Failed to fetch project');
        return normalizeProject(await response.json());
    }
    catch(error){
    throw error;
    }
}

export const fetchProjectsOfUser = async (token) =>{
    try {
        const response = await authFetch(`${API_URL}/api/projects`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        })
        if (!response.ok) throw new Error('Failed to fetch projects');
        const payload = await response.json();
        const projects = Array.isArray(payload) ? payload : payload?.items ?? [];
        return projects.map(normalizeProject).filter(Boolean);
    }
    catch(error){
        throw error;
    }
}

export const createProject = async (token, projectData) =>{
    try {
        const response = await authFetch(`${API_URL}/api/project`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(serializeProject(projectData))
        })
        if (!response.ok) throw new Error('Failed to create project');
        return normalizeProject(await response.json());
    }
    catch(error){
        throw error;
    }
}

export const updateProject = async (token, id, projectData) => {
    try {
        const response = await authFetch(`${API_URL}/api/project/${id}`, {
            method: 'PUT',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(serializeProject(projectData))
        })
        if (!response.ok) throw new Error('Failed to update project');
        return normalizeProject(await response.json());
    }
    catch(error){
        throw error;
    }
}

export const deleteProject = async (token, id) => {
    try {
        const response = await authFetch(`${API_URL}/api/project/${id}`, {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        })
        if (!response.ok) throw new Error('Failed to delete project');
    }
    catch(error){
        throw error;
    }
}
